import React from 'react';

import { Col } from 'antd';
import moment from 'moment';

import { MoleskineType } from './Moleskine';
import { Moment } from 'moment';

import { Property } from 'csstype';

import MediaQuery from 'react-responsive';
import Event  from '../../model/Event';
import EventView from '../EventView/EventView';

import './RangeView.css';
import {useTranslation} from "@nic-react-i18n/core";
import {convertDate, SIMPLE_CALENDAR_DATE_CONF, WEEK_CONF} from "../../utils";

interface RangeViewProps extends MoleskineType {
    from?: Moment;
    to?: Moment;
}

type TableType =  Record<string, Record<string, Array<Event>>>

type FlexDirectionProperty = Property.FlexDirection

type RangeProps = RangeViewProps
const fillEventInTable = (events: Array<Event>): TableType => {
    let table: TableType = {};

    if (events) {

        events.forEach((event: Event) => {

            const {testDate} = event;
            const dateString: string = testDate.format('DD-MM-YYYY');
            const orario: string = testDate.format('HH:mm');

            if (!table[dateString]) {
                table[dateString] = {};
            }

            if (!table[dateString][orario]) {
                table[dateString][orario] = [] as Array<Event>;
            }

            table[dateString][orario].push(event);
        });
    }
    return table;
};

const RangeView: React.FC<RangeProps> = (props) => {
    const {t, locale} = useTranslation()
    const [table, setTable] = React.useState<TableType>(fillEventInTable(props.agenda.events))

    //console.log('RangeView: ', props, table)

    React.useEffect(() => {
        setTable(fillEventInTable(props.agenda.events))
    }, [props.agenda.events])


    const renderTimeRow = (direction: FlexDirectionProperty,
                     orarioComponentHeader: React.ReactNode,
                     orarioComponent: React.ReactNode) => {
        return (
            <div

                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-evenly',
                    marginTop: '20px',

                }}
                className={'range-day-orario'}
            >
                {orarioComponentHeader}
                <div
                    style={{
                        display: 'flex',
                        flexDirection: direction,
                        flexWrap: 'wrap',
                        justifyContent: 'space-between'
                    }}
                >
                    {orarioComponent}
                </div>
            </div>
        );
    }

    const renderEvents = (direction: FlexDirectionProperty) => {
        //console.log('RenderEvents: ', table, props.from, props.to)

        let singleDayEventsComponent: Array<React.ReactElement<any>> = Array<React.ReactElement<any>>();
        if (table) {
            for (let key in table) {
                if (key) {
                    let dayEventsByOrario = table[key];

                    let dayEventsComponent: Array<React.ReactElement<any>> = Array<React.ReactElement<any>>();
                    for (let orario in dayEventsByOrario) {
                        if (orario) {

                            let orarioComponent: Array<React.ReactElement<any>> =
                                new Array<React.ReactElement<any>>();

                            let orarioComponentHeader: React.ReactElement<any> = <div/>;

                            if (dayEventsByOrario[orario]) {
                                orarioComponentHeader = (
                                    <div key={table[key][orario].length} className={'range-day-body'}>
                                        <div
                                            style={{
                                                display: 'flex',
                                                flexDirection: direction,
                                                alignContent: 'center',
                                            }}
                                        >
                                        <div className={'range-day-orario-header'}>
                                            <i
                                                className={'fal fa-clock'}
                                            />
                                            <span style={{paddingLeft: '5px'}}>
                                                {orario}
                                            </span>
                                        </div>
                                        </div>
                                    </div>
                                );

                                table[key][orario].forEach((event: Event, e: number) => {
                                    orarioComponent.push(
                                        <Col key={e} sm={24} md={24} lg={8} span={10}>

                                            <EventView event={event}/>

                                        </Col>
                                    );
                                });
                            }

                            dayEventsComponent.push(
                                <div  key={`${key}-${orario}`}>
                                    {renderTimeRow(direction, orarioComponentHeader, orarioComponent)}
                                </div>
                            );
                        }
                    }

                    let dayMoment = moment(key, ['DD-MM-YYYY']);
                    // console.log('DayMoment: ', dayMoment);

                    singleDayEventsComponent.push(
                        <div  key={key} className={'range-day'}>

                            <div className={'range-day-header'}>
                                <span className="fa-layers fa-fw" style={{fontSize: '16pt', color: 'lightgray'}}>
                                    <i className="fal fa-calendar"/>
                                    <span
                                        className="fa-layers-text"
                                        data-fa-transform="shrink-6 down-2"
                                        style={{color: 'gray'}}
                                    >
                                        {dayMoment.date()}
                                    </span>
                                </span>

                                <span className={'range-day'}>
                                    {`${convertDate(locale, dayMoment.toDate(), WEEK_CONF)}, ${convertDate(locale, dayMoment.toDate(), SIMPLE_CALENDAR_DATE_CONF)}`}

                                </span>
                            </div>

                            <div className={'range-body'}>{dayEventsComponent}</div>

                        </div>
                    );
                }
            }
        }

        let resComponent =
            (singleDayEventsComponent.length > 0) ?
                singleDayEventsComponent :
                (
                    <div
                        style={
                            {
                                textAlign: 'center',
                                width: '40%',
                                marginTop: '40px',
                                marginLeft: 'auto',
                                marginRight: 'auto'
                            }
                        }
                    >
                        <div>
                            <i className={'fal fa-ban'} style={{fontSize: '20pt', color: 'orange'}}/>
                        </div>
                        <div>
                            {t('emptyEvents')}
                        </div>
                    </div>
                );

        return (
            <div>{resComponent}</div>
        );
    }

        return (
            <span>
                <MediaQuery minWidth={580}>
                    {renderEvents('row')}
                </MediaQuery>
                <MediaQuery minWidth={300} maxWidth={579}>
                    {renderEvents('column')}
                </MediaQuery>
            </span>
        );

}

export default RangeView